import { AnalyticsEvent } from 'utils/analytics'
import { MUIDropdown } from 'components/common/MUIDropdown'
import { Stack } from '@mui/material'
import { TopBarDropdownButton } from './TopBarDropdownButton.component'
import { TopBarDropdownClientContent } from './TopBarDropdownClientContent.component'
import { TopBarDropdownInternalContent } from './TopBarDropdownInternalContent.component'
import { WHITE } from 'constants/styling/theme'
import { useAuth0 } from 'utils/auth'

/**
 * @interface Props for TopBarDropdown component
 */
export interface TopbarProps {
  /** Function to set the language open */
  setIsLanguageOpen: () => void
  /** Function to set the contact us open */
  setIsContactUsOpen: () => void
  /** Function to close the menu handler */
  closeMenuHandler: (e: React.MouseEvent<Element, MouseEvent>) => void
  /** Function to handle logout */
  handleLogout: (e: React.MouseEvent<Element, MouseEvent>) => void
  /** Function to handle log analytics event */
  handleLogAnalyticsEvent: (event: AnalyticsEvent, options?: {}) => void
  /** Callback to open the property selection drawer */
  onOpenPropertyDrawer?: () => void
  /** Starts a new order: the drafts dialog, the property drawer or the flow itself */
  onStartNewOrder?: () => void
}

/**
 * @component TopBarDropdownClient displayed TopBar
 * @example <TopBarDropdownClient />
 */
export const TopBarDropdownClient: React.FC<TopbarProps> = (props) => {
  const { roles } = useAuth0()

  return (
    <MUIDropdown
      button={(isOpen, action, onClose) => (
        <TopBarDropdownButton
          isOpen={isOpen}
          onClick={(e) => {
            isOpen ? onClose() : action(e)
            props.handleLogAnalyticsEvent(AnalyticsEvent.CLICK_MAIN_MENU)
          }}
        />
      )}
    >
      <Stack
        sx={{
          boxSizing: 'border-box',
          flexDirection: 'column',
          alignItems: 'flex-start',
          background: WHITE,
          fontWeight: 600,
          lineHeight: '140%',
          width: '24rem',
          padding: '1.4rem 1.6rem',
        }}
      >
        {roles.isClient && <TopBarDropdownClientContent {...props} />}
        {!roles.isClient && <TopBarDropdownInternalContent {...props} />}
      </Stack>
    </MUIDropdown>
  )
}
